import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "show-header"
};
import ContestHeader from '@/components/contest/ContestHeader.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(ContestHeader)]), _createElementVNode("div", null, [_createVNode(_component_router_view)])]);
    };
  }
});